import { createAction } from '@reduxjs/toolkit'
import { SnapshotType } from 'pages/Islands/IslandPage/IslandAnalyticsCard/utils/chartHelpers'

export const setSnapshotData = createAction<{ islandId: string; snapshots: SnapshotType[] }>('snapshot/setSnapshotData')
export const setLoading = createAction<{ islandId: string; loading: boolean }>('snapshot/setLoading')
